<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="经销商" prop="agentCodeLike">
                <el-input v-model="q.agentCodeLike" placeholder="请输入经销商编码或名称"></el-input>
              </el-form-item>
              <el-form-item label="渠道" prop="channelCode">
                <brselect category="fl_sales_region_main" :v="q.channelCode" v-model="q.channelCode" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="返利归属产业" prop="belongIndustry">
                <brselect category="fl_belong_industry" :v="q.belongIndustry" v-model="q.belongIndustry" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="签约链群" prop="lianqunCode">
                <brselect category="fl_25_chain_group" :v="q.lianqunCode" v-model="q.lianqunCode" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="状态" prop="used">
                    <brselect category="fl_lvyue_quit_status" :v="q.used" v-model="q.used"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="区域" prop="area">
                    <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="经销商类型" prop="agentNameLike">
                    <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="领域" prop="field">
                    <brselect category="fl_field" :v="q.field" v-model="q.field"
                              :clearable="true"/>
                  </el-form-item>
                </div>
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="年份" prop="year">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="q.year"
                        type="year"
                        value-format="yyyy"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="签约目标类别" prop="signType">
                    <brselect category="fl_goal_sign_type" :v="q.signType" v-model="q.signType" :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="是否计算销额" prop="isXiaoe">
                    <brselect category="fl_sale_is_jisuan" :v="q.isXiaoe" v-model="q.isXiaoe"/>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  :summary-method="getSummaries"
                  show-summary
                  max-height="530"
        >
          <el-table-column
              prop="area"
              :show-overflow-tooltip="true"
              label="区域"
              width="80"
              fixed
          >
          </el-table-column>
          <el-table-column
                  prop="agentType"
                  :show-overflow-tooltip="true"
                  label="经销商类型"
                  width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentType|dictname('fl_agent_type')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentCode"
              :show-overflow-tooltip="true"
              label="经销商编码"
              width="110"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="agentName"
              :show-overflow-tooltip="true"
              label="经销商名称"
              min-width="180"
              fixed
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
                prop="field"
                :show-overflow-tooltip="true"
                label="领域"
                width="80"
                fixed
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              {{scope.row.field|dictname('fl_field')}}
            </div>
          </template>
        </el-table-column>
          <el-table-column
              prop="channel"
              :show-overflow-tooltip="true"
              label="渠道"
              width="100"
              fixed
          >
          </el-table-column>
          <el-table-column
              prop="belongIndustry"
              :show-overflow-tooltip="true"
              label="返利归属产业"
              width="90"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.belongIndustry|dictname('fl_belong_industry')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="lianqun"
              :show-overflow-tooltip="true"
              label="签约链群"
              width="100"
              fixed
          >
          </el-table-column>
          <el-table-column label="1月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi1"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal1"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale1"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv1"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="2月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi2"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal2"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale2"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv2"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="3月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi3"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal3"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale3"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv3"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="一季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqiQ1"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqiQ1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goalQ1"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goalQ1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="saleQ1"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.saleQ1).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lvQ1"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="4月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi4"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal4"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale4"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv4"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="5月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi5"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal5"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale5"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale5).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv5"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="6月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi6"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal6"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale6"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale6).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv6"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="二季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqiQ2"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqiQ2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goalQ2"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goalQ2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="saleQ2"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.saleQ2).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lvQ2"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="7月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi7"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal7"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale7"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale7).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv7"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="8月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi8"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal8"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale8"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale8).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv8"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="9月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi9"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal9"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale9"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale9).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv9"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="三季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqiQ3"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqiQ3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goalQ3"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goalQ3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="saleQ3"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.saleQ3).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lvQ3"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="10月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi10"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal10"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale10"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale10).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv10"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="11月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi11"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal11"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale11"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale11).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv11"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="12月" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqi12"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqi12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal12"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goal12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sale12"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.sale12).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lv12"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="四季度" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqiQ4"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqiQ4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goalQ4"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goalQ4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="saleQ4"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.saleQ4).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lvQ4"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年合计" :show-overflow-tooltip="true">
            <el-table-column
                    prop="tongqiYear"
                    :show-overflow-tooltip="true"
                    label="同期(万元)"
                    width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.tongqiYear).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goalYear"
                :show-overflow-tooltip="true"
                label="目标(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.goalYear).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="saleYear"
                :show-overflow-tooltip="true"
                label="销额(万元)"
                width="100"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.saleYear).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="lvYear"
                :show-overflow-tooltip="true"
                label="履约率"
                width="80"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column
              prop="signType"
              :show-overflow-tooltip="true"
              label="签约目标类别"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.signType | dictname('fl_goal_sign_type')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="used"
              :show-overflow-tooltip="true"
              label="状态"
              width="80"
          >
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.used | dictname('fl_lvyue_quit_status')}}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        year: new Date().getFullYear().toString(),
        agentCodeLike: '',
        channelCode: null,
        lianqunCode: null,
        type: '',
        used:null,
        areaCode: null,
        signType:null,
        isXiaoe:'X',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      //table列表
      tableData: [],
      lv:'',
    }
  },
  created() {
    this.q = {
      year: new Date().getFullYear().toString(),
      agentCodeLike: '',
      channelCode: null,
      lianqunCode: null,
      type: '',
      used:null,
      areaCode: null,
      signType:null,
      isXiaoe:'X',
      pageSize: 10,
      pageNo: 1,
      total: 0
    };
    this.handleFilter();
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    //检索
    handleFilter() {
      this.query();
      this.queryTotal();
    },
    //重置
    reset() {
      this.q = {
        year: new Date().getFullYear().toString(),
        agentCodeLike: '',
        channelCode: null,
        lianqunCode: null,
        type: '',
        used:null,
        areaCode: null,
        signType:null,
        isXiaoe:'X',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      this.handleFilter();
    },
    //查询table
    query() {
      ss.fanli.getLyAllPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    queryTotal() {
      ss.fanli.getLyAllTotal(this.q).then(rd=>{
        this.lv = rd;
      });

    },
    //批量导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/fanli/flLvyueTableAll/downloadExcelAll", this.q, "post");
    },
    //求和汇总
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        console.log(column,index)
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[8] = Number(this.lv.tongqi1).toFixed(2);
          sums[9] = Number(this.lv.goal1).toFixed(2);
          sums[10] = Number(this.lv.sale1).toFixed(2);
          sums[11] = this.lv.lv1;
          sums[12] = Number(this.lv.tongqi2).toFixed(2);
          sums[13] = Number(this.lv.goal2).toFixed(2);
          sums[14] = Number(this.lv.sale2).toFixed(2);
          sums[15] = this.lv.lv2;
          sums[16] = Number(this.lv.tongqi3).toFixed(2);
          sums[17] = Number(this.lv.goal3).toFixed(2);
          sums[18] = Number(this.lv.sale3).toFixed(2);
          sums[19] = this.lv.lv3;
          sums[20] = Number(this.lv.tongqiQ1).toFixed(2);
          sums[21] = Number(this.lv.goalQ1).toFixed(2);
          sums[22] = Number(this.lv.saleQ1).toFixed(2);
          sums[23] = this.lv.lvQ1;
          sums[24] = Number(this.lv.tongqi4).toFixed(2);
          sums[25] = Number(this.lv.goal4).toFixed(2);
          sums[26] = Number(this.lv.sale4).toFixed(2);
          sums[27] = this.lv.lv4;
          sums[28] = Number(this.lv.tongqi5).toFixed(2);
          sums[29] = Number(this.lv.goal5).toFixed(2);
          sums[30] = Number(this.lv.sale5).toFixed(2);
          sums[31] = this.lv.lv5;
          sums[32] = Number(this.lv.tongqi6).toFixed(2);
          sums[33] = Number(this.lv.goal6).toFixed(2);
          sums[34] = Number(this.lv.sale6).toFixed(2);
          sums[35] = this.lv.lv6;
          sums[36] = Number(this.lv.tongqiQ2).toFixed(2);
          sums[37] = Number(this.lv.goalQ2).toFixed(2);
          sums[38] = Number(this.lv.saleQ2).toFixed(2);
          sums[39] = this.lv.lvQ2;
          sums[40] = Number(this.lv.tongqi7).toFixed(2);
          sums[41] = Number(this.lv.goal7).toFixed(2);
          sums[42] = Number(this.lv.sale7).toFixed(2);
          sums[43] = this.lv.lv7;
          sums[44] = Number(this.lv.tongqi8).toFixed(2);
          sums[45] = Number(this.lv.goal8).toFixed(2);
          sums[46] = Number(this.lv.sale8).toFixed(2);
          sums[47] = this.lv.lv8;
          sums[48] = Number(this.lv.tongqi9).toFixed(2);
          sums[49] = Number(this.lv.goal9).toFixed(2);
          sums[50] = Number(this.lv.sale9).toFixed(2);
          sums[51] = this.lv.lv9;
          sums[52] = Number(this.lv.tongqiQ3).toFixed(2);
          sums[53] = Number(this.lv.goalQ3).toFixed(2);
          sums[54] = Number(this.lv.saleQ3).toFixed(2);
          sums[55] = this.lv.lvQ3;
          sums[56] = Number(this.lv.tongqi10).toFixed(2);
          sums[57] = Number(this.lv.goal10).toFixed(2);
          sums[58] = Number(this.lv.sale10).toFixed(2);
          sums[59] = this.lv.lv10;
          sums[60] = Number(this.lv.tongqi11).toFixed(2);
          sums[61] = Number(this.lv.goal11).toFixed(2);
          sums[62] = Number(this.lv.sale11).toFixed(2);
          sums[63] = this.lv.lv11;
          sums[64] = Number(this.lv.tongqi12).toFixed(2);
          sums[65] = Number(this.lv.goal12).toFixed(2);
          sums[66] = Number(this.lv.sale12).toFixed(2);
          sums[67] = this.lv.lv12;
          sums[68] = Number(this.lv.tongqiQ4).toFixed(2);
          sums[69] = Number(this.lv.goalQ4).toFixed(2);
          sums[70] = Number(this.lv.saleQ4).toFixed(2);
          sums[71] = this.lv.lvQ4;
          sums[72] = Number(this.lv.tongqiYear).toFixed(2);
          sums[73] = Number(this.lv.goalYear).toFixed(2);
          sums[74] = Number(this.lv.saleYear).toFixed(2);
          sums[75] = this.lv.lvYear;
        } else {
          sums[0] = '';
          sums[1] = '';
          sums[2] = '';
          sums[3] = '';
          sums[4] = '';
          sums[5] = '';
          sums[6] = '';
          sums[7] = '';
          sums[76] = '';
        }
      });
      return sums;
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}

.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}

.w-content .el-table__fixed-footer-wrapper tbody td {
  background: #cce7ff;
}

.w-content .el-table__footer-wrapper tbody td {
  background: #cce7ff;
}

.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}

.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}

.el-table__fixed-footer-wrapper tbody td {
  border-top: 0;
}
</style>
